
import { Fraga } from "@/types/riskbedomning";

export const blastingRiskFragor: Fraga[] = [
  {
    id: "sprangningsarbeten",
    text: "Kommer sprängningsarbeten att utföras?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Kan avsaknad eller brister i sprängplan, riskbedömning, byggnadsanalys eller varningsrutiner leda till olyckor, skador på konstruktioner eller fara för personal och allmänhet?"
    ]
  }
];
